export const settingsCategories = [
  'generalNotifications',
  'paymentNotifications',
  'fundingRequestNotifications',
  'bankingNotifications',
] as const;
